<template>
  <div>
    <table-view
      ref="tableList"
      :isMultiple="true"
      :isSearchLoading="isAllLoad"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="page"
      @pageChange="pageChange"
      @searchChange="handleSearchChange"
      tableCardTitle="LIST"
      :isSearchRow="false"
      :isTableLoading="isTableLoading"
      @selectionChange="selectionChange"
      @clickClearBtn="handleClickClearBtn"
    >
      <template v-slot:bpmId="{ tableRow }">
        <a href="javascript:void(0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.bpmId }}
        </a>
      </template>
      <template v-slot:companyName="{ tableRow }">
        <a
          href="javascript:void(0)"
          @click="handleHrefCustomerProfile(tableRow.row)"
        >
          {{ tableRow.row.companyName }}
        </a>
      </template>
      <template v-slot:customerType="{ tableRow }">
        {{ getCustomerType(tableRow.row.customerType) }}
      </template>
      <template v-slot:vagueSearch>
        <el-form-item label="Assigned To">
          <el-select
            v-model="assignedTo"
            style="width: 261px"
            filterable
            remote
            placeholder="please select"
            :loading="assignLoading"
            :remote-method="queryName"
            clearable
          >
            <el-option
              v-for="name in nameOptions"
              :key="name.id"
              :label="name.username"
              :value="name.username"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <!--      因为tableList的rightBtn现只1个btn, （改动地方很多）所以用插槽-->
      <template v-slot:btnArr>
        <customize-button
          class="rightBtn"
          type="primary"
          @click="handleReassign"
        >
          Reassign
        </customize-button>
        <customize-button class="rightBtn" type="primary" @click="setPriority">
          Priority
        </customize-button>
      </template>
    </table-view>
    <!--    弹窗-->
    <el-dialog
      title="Reassign"
      :visible.sync="reassignVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-select
          remote
          filterable
          v-model="reassignedTo"
          placeholder="reassign to"
          :remote-method="remoteReassign"
          :loading="reassignLoading"
          style="width: 100%"
        >
          <el-option
            v-for="item in reassignList"
            :value="item.username"
            :key="item.username"
            :label="item.username"
          ></el-option>
        </el-select>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <customize-button
          @click="reassignVisible = false"
          style="margin-right: 24px"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="confirmReassign">
          Assign
        </customize-button>
      </span>
    </el-dialog>
    <!--    priority 弹窗-->
    <el-dialog
      title="Priority"
      :visible.sync="priorityVisible"
      width="400px"
      :close-on-click-modal="false"
      @close="handlePriorityClose"
    >
      <el-card shadow="never">
        <el-select v-model="priorityForm.priority" style="width: 100%">
          <el-option :value="1" label="High" />
          <el-option :value="2" label="Medium" />
          <el-option :value="3" label="Low" />
        </el-select>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <customize-button
          @click="priorityVisible = false"
          style="margin-right: 24px"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handlePriority">
          Assign
        </customize-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getSelectList } from '@/api'
import {
  getTableData,
  getAssign,
  saveAssign,
  getCssDetail,
  savePriority,
} from './api'

const selectList = ['Country', 'Region', 'CCA', 'Business', 'Geo']

export default {
  data() {
    const searchModel = [
      { label: 'Trans#', type: 'input', key: 'bpmId' },
      { label: 'Customer#', type: 'input', key: 'companyCode' },
      { label: 'Customer Name', type: 'input', key: 'companyName' },
      {
        label: 'GEO',
        type: 'select',
        key: 'geo',
        selectList: [],
      },
      {
        label: 'Region',
        type: 'select',
        key: 'region',
        selectList: [],
      },
      {
        label: 'Credit Category',
        type: 'select',
        key: 'creditCategory',
        selectList: [
          {
            id: 1,
            name: 'BAU',
          },
          {
            id: 2,
            name: 'Uplift',
          },
          {
            id: 3,
            name: 'Extension',
          },
          {
            id: 4,
            name: 'PCR',
          },
          {
            id: 5,
            name: 'Condition Update',
          },
          {
            id: 6,
            name: 'Waiver',
          },
          {
            id: 7,
            name: 'Invoice Extension',
          },
        ],
      },
      {
        label: 'Customer Type',
        type: 'select',
        key: 'customerType',
        selectList: [
          {
            id: 1,
            name: 'Trade',
          },
          {
            id: 2,
            name: 'Eaas',
          },
          {
            id: 3,
            name: 'Saas',
          },
        ],
      },
    ]
    const tableModel = [
      { width: 200, slotName: 'bpmId', label: 'Trans#' },
      { width: 120, prop: 'companyCode', label: 'Customer#' },
      { width: 200, slotName: 'companyName', label: 'Customer Name' },
      { slotName: 'customerType', label: 'Customer Type', width: 200 },
      { width: 120, prop: 'approver', label: 'Assigned To' },
      { width: 120, prop: 'geoStr', label: 'GEO' },
      { width: 120, prop: 'regionStr', label: 'Region' },
      { width: 120, prop: 'salesCountryStr', label: 'Sales Country' },
      { width: 120, prop: 'typeStr', label: 'Category' },
      { width: 120, prop: 'createTime', label: 'Due Date' },
      { width: 120, prop: 'priorityStr', label: 'Priority' },
    ]
    return {
      isTableLoading: true,
      isAllLoad: true,
      searchModel,
      tableModel,
      tableData: [],
      page: {},
      assignedTo: '',
      assignLoading: false,
      nameOptions: [],
      tableSelectList: [],
      reassignVisible: false,
      //  弹窗数据
      reassignList: [],
      reassignedTo: '',

      reassignLoading: false,
      // priority
      priorityVisible: false,
      priorityForm: { priority: '' },
    }
  },
  created() {
    // 获取下拉列表
    this.getAllSelect()
    if (this.$store.state.source === 2) {
      this.searchModel.splice(6, 1)
    }
  },
  mounted() {
    this.initTable()
    if (this.$store.state.source === 2) {
      this.tableModel.splice(3, 1)
    }
  },
  methods: {
    getCustomerType(type) {
      console.log(type)
      switch (type) {
        case 1:
          return 'Trade'
        case 2:
          return 'Eaas'
        case 3:
          return 'Saas'
        case 4:
          return 'CSS'
        default:
          return ''
      }
    },
    handleClickClearBtn() {
      this.assignedTo = ''
      this.nameOptions = []
    },
    initTable() {
      const params = {
        current: 1,
        size: 10,
        assignedTo: this.assignedTo,
      }
      this._getTableList(params)
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [countryList, regionList, ccaList, businessList, geoList] =
              res
            for (let i = 0; i < this.searchModel.length; i++) {
              const item = this.searchModel[i]
              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = geoList
              }
            }
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.log(`search 列表查询错误:${err}`)
        })
    },
    // 异步请求下拉列表数据
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取table 数据
    async _getTableList(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableData(params)
        // data.map(item => {
        //   item.createTime = dayjs(item.createTime)
        //     .subtract(-2, 'day')
        //     .format('YYYY-MM-DD HH:mm:ss')
        // })
        this.tableData = data
        this.page = page
        this.isTableLoading = false
      } catch (err) {
        console.log(err)
      }
    },
    // search click callback
    handleSearchChange(params) {
      const _params = Object.assign({}, params, { assignedTo: this.assignedTo })
      _params.current = 1
      this._getTableList(_params)
    },
    // 跳转到详情页
    async handleHrefInfoPage(tableRow) {
      this.$storage.setItem('bpmId', tableRow.bpmId)
      if (tableRow.source === 2) {
        // CSS
        // 根据status跳转;1为pending状态(跳到final);6为condition approved状态(跳到二次审核)
        const params = {
          bpmId: tableRow.bpmId || this.$storage.getItem('bpmId'),
        }
        const { creditInfo, additionalConditionsVOList, running, process } =
          await getCssDetail(params)
        if (creditInfo.status === 6) {
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-second-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else if (
          (creditInfo.status === 1 &&
            additionalConditionsVOList.length === 0 &&
            process.length === 2) ||
          (creditInfo.decisionType === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          (creditInfo.decisionType === 4 &&
            creditInfo.status === 1 &&
            additionalConditionsVOList.length !== 0 &&
            running === 1) ||
          running === 1
        ) {
          // pending
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        } else {
          let routeUrl = this.$router.resolve({
            path: `/credit-management/css-audit/css-final-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
          })
          window.open(routeUrl.href, '_blank')
        }
        return
      }
      let routeUrl = this.$router.resolve({
        path: `/credit-management/credit-audit/single-audit?bpmId=${tableRow.bpmId}&companyCode=${tableRow.companyCode}`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
    },
    // 跳转到customer basicProfile
    handleHrefCustomerProfile({ companyId }) {
      let routeUrl = this.$router.resolve({
        path: `/customer-management/${companyId}/info/basic-profile`,
      })
      window.open(routeUrl.href, '_blank')
    },
    pageChange(curPage) {
      console.log(curPage, 'curPage')
      const queryForm = {}
      const params = Object.assign({}, queryForm, {
        assignedTo: this.assignedTo,
        current: curPage.current,
        size: 10,
        region: curPage.region,
        geo: curPage.geo,
        bpmId: curPage.bpmId,
        creditCategory: curPage.creditCategory,
        companyCode: curPage.companyCode,
        companyName: curPage.companyName,
        customerType: curPage.customerType,
      })
      this._getTableList(params)
    },
    queryName(query) {
      this._getAssign(query)
    },
    async _getAssign(query) {
      try {
        this.nameOptions = await getAssign(query)
      } catch (err) {
        console.log(err)
      }
    },
    handleReassign() {
      if (this.tableSelectList.length) {
        this.reassignVisible = true
      } else {
        this.$message.warning('please choose')
      }
    },
    async confirmReassign() {
      if (this.reassignedTo === '') {
        return this.$message.error('please choose')
      }
      try {
        const params = {
          assignTo: this.reassignedTo,
          bpmIds: this.tableSelectList.map(item => item.bpmId),
        }
        await saveAssign(params)
        this.$message.success('success')
        this.reassignVisible = false
        this.tableSelectList = []
        const _params = this.$refs.tableList.getSearchData()
        this._getTableList(_params)
      } catch (err) {
        console.log(err)
      }
    },
    selectionChange(selectList) {
      this.tableSelectList = selectList
    },
    async remoteReassign(query) {
      if (query !== '') {
        this.reassignLoading = true
        this.reassignList = await getAssign(query)
        this.reassignLoading = false
      } else {
        this.reassignList = []
      }
    },
    setPriority() {
      if (this.tableSelectList.length) {
        this.priorityVisible = true
      } else {
        this.$message.warning('please choose')
      }
    },
    handlePriorityClose() {
      this.priorityForm.priority = ''
    },
    // 确定set priority
    async handlePriority() {
      const params = {
        ...this.priorityForm,
      }
      if (!params.priority) {
        return this.$message.error('please choose')
      }
      params.bpmIds = this.tableSelectList.map(item => item.bpmId)
      try {
        await savePriority(params)
        this.$message.success('success')
        const _params = this.$refs.tableList.getSearchData()
        this._getTableList(_params)
        this.priorityVisible = false
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>
<style scoped lang="less">
.rightBtn {
  margin-right: 24px;
}
</style>
